import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { getDefaultDiscountText } from "@/common/util/get-default-discount-text";
import { Body14Medium } from "@/components/typography/Body14Medium";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strikethrough } from "@/components/typography/Body14Strikethrough";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { CartItemDto } from "@/types/dto/cart-item-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  data: CartItemDto;
  index: number;
}

export const ItemRow: React.FC<Props> = ({ data, index }) => {
  const item = data;

  return (
    <Table.Row
      key={item.id}
      className={`bg-white text-semantic-text-body group-[.divide-y]:divide-y-0 `}
    >
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Regular>{index + 1}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <div className="box-border flex items-start m-4 min-h-fit">
          <div className="flex flex-col">
            <div className="flex">
              {item.imageUrls.length > 0 && (
                <img
                  src={item.imageUrls[0]}
                  alt={item.name}
                  className="w-[32px] mr-[8px]"
                />
              )}
              <Body14Regular>{item.name}</Body14Regular>
            </div>
            {item.memoItems && item.memoItems.length > 0 && (
              <div className="flex gap-2 mt-4">
                <img
                  src="/svg/arrow-mid-outline.svg"
                  alt="arrow"
                  className="w-6 h-6"
                />
                <div className="flex flex-col gap-2">
                  {item.memoItems.map((item) => (
                    <div className="flex flex-col ">
                      <Body14Medium className="text-semantic-text-body">
                        {item.name}
                      </Body14Medium>
                      <Footnote12Description className="text-semantic-text-secondary">
                        {item.value}
                      </Footnote12Description>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Regular>{item.quantity}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Medium className="text-semantic-text-body">
            {getDefaultDiscountText(item)}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Medium className="text-secondary-2-orange">
            {`인센티브 할인 ${item.incentiveDiscountRate}%`}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell className="flex gap-[12px]">
          <Body14Strikethrough className="text-semantic-text-tertiary">
            {formatCommasNumber(item.originalPrice)}
          </Body14Strikethrough>
          <Body14Medium className="text-semantic-text-body">
            {formatCommasNumber(item.totalPrice)}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
